var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeStriked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4.5c2.8 0 5.2 1.3 7.3 3.5.7.8 1.3 1.6 1.8 2.4l.2.3.3.6.2.2c.1.3.1.6 0 .9l-.1.2c-.1.2-.2.3-.3.6l-.3.3c-.5.8-1.1 1.6-1.8 2.4-2.1 2.2-4.5 3.5-7.3 3.5s-5.2-1.3-7.3-3.5c-.7-.8-1.3-1.6-1.8-2.4L1 9.2l-.4-.8c-.1-.3-.1-.6 0-.9l.4-.8.2-.3C1.7 5.6 2.3 4.8 3 4 5.2 1.8 7.6.5 10.4.5zm0 2c-2.2 0-4.1 1.1-5.8 2.9-.5.5-1 1.1-1.4 1.7l-.3.5-.3.4.1.1.2.3c.5.7 1 1.4 1.6 2.1 1.7 1.8 3.7 2.9 5.8 2.9s4.1-1.1 5.8-2.9c.6-.7 1.2-1.4 1.6-2.1l.1-.2.2-.3-.1-.1-.1-.3c-.5-.7-1-1.4-1.6-2.1-1.7-1.8-3.7-2.9-5.8-2.9zm0 2c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4S7 9.9 7 8s1.5-3.5 3.4-3.5zm0 2C9.6 6.5 9 7.2 9 8s.6 1.4 1.4 1.4c.8 0 1.4-.6 1.4-1.4s-.6-1.5-1.4-1.5z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M1.9 14.7L16.7.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeStriked);
export default __webpack_public_path__ + "static/media/eye-striked.c770faf75ebc769981e66fb5c596d101.svg";
export { ForwardRef as ReactComponent };